/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form, Grid } from '@mairistem/composants';

import { AssistantContext } from '@/contexts';

import { Steps } from '@/types';
import AdresseContact from './InformationsContact';
import AdresseRattachement from './AdresseRattachement';

const StepAdressesContacts = () => {
  const {
    tel1,
    tel2,
    mail,
    adresseRattachement,
    adresseContact,
    isResideCommune,
    recensement,
    errors,
    onChange,
  } = React.useContext(AssistantContext);

  const errorsStep = errors?.[Steps.AdressesContacts] || {};

  return (
    <Grid as={Form} padded>
      <Grid.Row style={{ paddingTop: '0px' }}>
        <Grid.Column>
          <AdresseRattachement
            isResideCommune={isResideCommune}
            adresseRattachement={adresseRattachement}
            errors={errorsStep}
            onChange={onChange}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: '0px' }}>
        <Grid.Column>
          <AdresseContact
            tel1={tel1}
            tel2={tel2}
            mail={mail}
            adresseContact={adresseContact}
            adresseRattachement={adresseRattachement}
            recensement={recensement}
            errors={errorsStep}
            onChange={onChange}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default StepAdressesContacts;
